import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useSearchParam } from 'react-use';
import {
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { SEARCH_DEBOUNCE_TIMEOUT_MS } from '../constants';
import { SearchContext } from './SearchContext';

export const SearchContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const searchParam = useSearchParam('search') || '';
  const { messageMedium } = useParams<{ messageMedium: string }>();
  const [inputValue, setInputValue] = useState(searchParam || '');

  const [debouncedValue, setDebouncedValue] = useSearchParamState({
    searchParamKey: 'search',
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  useDebouncedEffect(() => setDebouncedValue(inputValue), [inputValue], {
    debounceTimeout: SEARCH_DEBOUNCE_TIMEOUT_MS,
    skipEffectOnMount: false,
  });

  // reset search value when switching message mediums, keep search param on page refresh
  useEffect(() => setInputValue(searchParam), [messageMedium]);

  return (
    <SearchContext.Provider value={{ debouncedValue, inputValue, setInputValue }}>
      {children}
    </SearchContext.Provider>
  );
};
